import {
  SET_BOT_LIST,
  SET_AI_BOT_ID,
  RESET_STATE_AI_BOT
} from '../mutation-types'

const state = getDefaultState()

function getDefaultState() {
  return JSON.parse(
    JSON.stringify({
      appId: '',
      botList: []
    })
  )
}

const getters = {
  appId: state => state.appId,
  aiBotName: state =>
    state.botList.find(item => item.id === state.appId).aiBotName || '',
  botList: state => state.botList
}

const mutations = {
  [SET_BOT_LIST](state, list) {
    state.botList = list
  },
  [SET_AI_BOT_ID](state, id) {
    state.appId = id
  },
  [RESET_STATE_AI_BOT](state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/jMeAiBotState.js